<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_ix"></a><a id="page_x"><em class="italic">For</em></a></p><a id="page_x">
<p class="dedit"><em class="italic">Ken and Janet Swinhoe—and the other Amy</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?27b67be6